import { render, staticRenderFns } from "./ChoiceVueComponent.vue?vue&type=template&id=cdcaf212&"
import script from "./ChoiceVueComponent.vue?vue&type=script&lang=ts&"
export * from "./ChoiceVueComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ChoiceVueComponent.vue?vue&type=style&index=0&id=cdcaf212&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports